import { render, staticRenderFns } from "./WeightsCounterPopup.vue?vue&type=template&id=2df8d2c1&scoped=true&"
import script from "./WeightsCounterPopup.vue?vue&type=script&lang=ts&"
export * from "./WeightsCounterPopup.vue?vue&type=script&lang=ts&"
import style0 from "./WeightsCounterPopup.vue?vue&type=style&index=0&id=2df8d2c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df8d2c1",
  null
  
)

export default component.exports